import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import { Toaster } from "sonner";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Landing from "@/pages/Landing";
import Directory from "@/pages/Directory";
import FarmDetail from "@/pages/FarmDetail";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import Admin from "@/pages/Admin";
import About from "@/pages/About";
import JoinNetwork from "@/pages/JoinNetwork";
import MembershipResult from "@/pages/MembershipResult";
import Suggest from "@/pages/Suggest";
import Projects from "@/pages/Projects";
import ProjectDetail from "@/pages/ProjectDetail";
import "@/App.css";

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <div className="flex flex-col min-h-screen bg-[#FBF9F6]">
          <Navbar/>
          <main className="flex-1">
            <Routes>
              <Route path="/" element={<Landing/>}/>
              <Route path="/fattorie" element={<Directory/>}/>
              <Route path="/fattorie/:id" element={<FarmDetail/>}/>
              <Route path="/login" element={<Login/>}/>
              <Route path="/register" element={<Register/>}/>
              <Route path="/dashboard" element={<Dashboard/>}/>
              <Route path="/admin" element={<Admin/>}/>
              <Route path="/chi-siamo" element={<About/>}/>
              <Route path="/adesione" element={<JoinNetwork/>}/>
              <Route path="/adesione/success" element={<MembershipResult outcome="success"/>}/>
              <Route path="/adesione/cancel" element={<MembershipResult outcome="cancel"/>}/>
              <Route path="/segnala" element={<Suggest/>}/>
              <Route path="/progetti" element={<Projects/>}/>
              <Route path="/progetti/:id" element={<ProjectDetail/>}/>
            </Routes>
          </main>
          <Footer/>
        </div>
        <Toaster position="top-right" richColors closeButton/>
      </BrowserRouter>
    </AuthProvider>
  );
}
